import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./MerchantUIHelper";
const MerchantUIContext = createContext();

export function useMerchantUIContext() {
  return useContext(MerchantUIContext);
}

export const MerchantUIConsumer = MerchantUIContext.Consumer;

export function MerchantUIProvider({ merchantUIEvents, children }) {
  // initial filter
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  // Query Params set when do pagination ,filter,search
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const [ids, setIds] = useState([]);

  const value = {
    ids,
    setIds,
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    newMerchantButtonClick: merchantUIEvents.newMerchantButtonClick,
    openEditMerchantPage: merchantUIEvents.openEditMerchantPage,
    openDeleteMerchantDialog: merchantUIEvents.openDeleteMerchantDialog,
    sendEmailMerchant: merchantUIEvents.sendEmailMerchant,
    openViewMerchantDialog: merchantUIEvents.openViewMerchantDialog,
    newPortalMerchantButtonClick: merchantUIEvents.newPortalMerchantButtonClick,
    openEditPortalMerchantPage: merchantUIEvents.openEditPortalMerchantPage,
    openDeletePortalMerchantDialog: merchantUIEvents.openDeletePortalMerchantDialog,
  };
  return (
    <MerchantUIContext.Provider value={value}>{children}</MerchantUIContext.Provider>
  );
}
